import styled from 'styled-components'
import { BREAKPOINTS } from '../../constants/breakpoints'

export const LegalInformationContainer = styled.div`
  width: 100%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  border-top: 1px solid #ededed;
  border-bottom: 1px solid #ededed;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 16px;

  @media ${BREAKPOINTS.md} {
    padding: 20px 40px 20px 40px;
  }
`

export const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`

export const HeaderTitle = styled.h1`
  font-family: Ubuntu, sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.02em;
  color: ${({ isOpen }: { isOpen: boolean }) =>
    isOpen ? '#0093b2' : '#6e6e6e'};
`

export const OpenCollapse = styled.img``

export const BodyContainer = styled.div`
  padding: 0;

  @media ${BREAKPOINTS.md} {
    padding: 20px;
  }
`

export const Paragraph = styled.p`
  font-family: Ubuntu, sans-serif;
  font-size: 16px;
  font-weight: 300;
  line-height: 24px;
  letter-spacing: 0.02em;
  color: #6e6e6e;
  text-align: left;
`
